import { createSelector } from '@ngrx/store';
import { IAccessSettingsState } from './access-settings.reducer';
import { IProject } from '../interfaces';

export const selectAccessSettingState = (state: any) => state.accessSettings;

export const selectProjects = createSelector(
  selectAccessSettingState,
  (accessSettingState: IAccessSettingsState) => accessSettingState.list,
);

export const selectProjectsCount = createSelector(
  selectAccessSettingState,
  (accessSettingState: IAccessSettingsState) => accessSettingState.count,
);

export const selectProject = createSelector(selectProjects, (projects: IProject[], props: { id: number | null }) => {
  if (props.id === null) return null;
  return projects.find((project: IProject) => project.id === props.id);
});
